__turbopack_context__.v({
  "action": "editorial-module__sca1Oq__action",
  "articleActions": "editorial-module__sca1Oq__articleActions",
  "articleBody": "editorial-module__sca1Oq__articleBody",
  "articleDeck": "editorial-module__sca1Oq__articleDeck",
  "articleGrid": "editorial-module__sca1Oq__articleGrid",
  "articleHeader": "editorial-module__sca1Oq__articleHeader",
  "articleTitle": "editorial-module__sca1Oq__articleTitle",
  "browse": "editorial-module__sca1Oq__browse",
  "browseHeader": "editorial-module__sca1Oq__browseHeader",
  "byline": "editorial-module__sca1Oq__byline",
  "caseAuthor": "editorial-module__sca1Oq__caseAuthor",
  "caseBio": "editorial-module__sca1Oq__caseBio",
  "caseGrid": "editorial-module__sca1Oq__caseGrid",
  "caseHeader": "editorial-module__sca1Oq__caseHeader",
  "caseHeaderGrid": "editorial-module__sca1Oq__caseHeaderGrid",
  "caseHero": "editorial-module__sca1Oq__caseHero",
  "caseProfile": "editorial-module__sca1Oq__caseProfile",
  "contents": "editorial-module__sca1Oq__contents",
  "desktopContents": "editorial-module__sca1Oq__desktopContents",
  "faq": "editorial-module__sca1Oq__faq",
  "feature": "editorial-module__sca1Oq__feature",
  "featureArtwork": "editorial-module__sca1Oq__featureArtwork",
  "filters": "editorial-module__sca1Oq__filters",
  "indexHeader": "editorial-module__sca1Oq__indexHeader",
  "label": "editorial-module__sca1Oq__label",
  "mobileContents": "editorial-module__sca1Oq__mobileContents",
  "muted": "editorial-module__sca1Oq__muted",
  "nextActions": "editorial-module__sca1Oq__nextActions",
  "nextStep": "editorial-module__sca1Oq__nextStep",
  "page": "editorial-module__sca1Oq__page",
  "postArt": "editorial-module__sca1Oq__postArt",
  "postCard": "editorial-module__sca1Oq__postCard",
  "postCollection": "editorial-module__sca1Oq__postCollection",
  "postCopy": "editorial-module__sca1Oq__postCopy",
  "primaryAction": "editorial-module__sca1Oq__primaryAction",
  "prose": "editorial-module__sca1Oq__prose",
  "rail": "editorial-module__sca1Oq__rail",
  "related": "editorial-module__sca1Oq__related",
  "relatedArt": "editorial-module__sca1Oq__relatedArt",
  "relatedGrid": "editorial-module__sca1Oq__relatedGrid",
  "resultCount": "editorial-module__sca1Oq__resultCount",
  "rowCategory": "editorial-module__sca1Oq__rowCategory",
  "rowMeta": "editorial-module__sca1Oq__rowMeta",
  "search": "editorial-module__sca1Oq__search",
  "showMore": "editorial-module__sca1Oq__showMore",
  "table": "editorial-module__sca1Oq__table",
  "takeaways": "editorial-module__sca1Oq__takeaways",
  "technical": "editorial-module__sca1Oq__technical",
  "topline": "editorial-module__sca1Oq__topline",
});
